<template lang="pug">
  .post-comment.post-re-comment
    img.post-comment__user-icon(
      :src="reComment.author_logo"
    )
    .post-comment__body
      .post-comment__user-name {{ reComment.author }}
        .post-comment__date {{ postTime }}
          .post-counter
            img.post-counter__icon(src="../../assets/images/icon-like.svg")
            .post-counter__count {{ reComment.likes }}
      .post-comment__text(v-html="reCommentText(reComment.text)")
</template>

<script>
import PostComment from '@/components/posts/postComment.vue';

export default {
  name: 'postReComment',
  components: { PostComment },
  props: {
    reComment: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      postTime: '',
      regex: /\[(.*?)\]/g,
      social: {
        '1': {
          domen: 'https://vk.com/',
        },
        '3': {
          domen: 'https://www.facebook.com/',
        },
        '2': {
          domen: 'https://twitter.com/',
        },
      },
    };
  },
  mounted() {
    this.updateTime();
    setInterval(() => {
      this.updateTime();
    }, 60000);
  },
  methods: {
    replaceByNetwork(text) {
      const matches = text.match(this.regex);

      if (matches) {
        const matchedValues = matches.map(match => match.replace('[', this.social[this.reComment.network_id].domen).replace(']', '')).join(' ');
        const matchedArray = matchedValues.split('|');
        const link = `<a href="${matchedArray[0]}" target="_blank">${matchedArray[1]}</a>`;
        return text.replace(matches[0], link);
      }

      return text;
    },
    reCommentText(text) {
      return this.replaceByNetwork(text);
    },
    updateTime() {
      this.postTime = this.$moment(this.reComment.created_date).fromNow()
    },
  }
};
</script>

<style lang="stylus">
.post-comment.post-re-comment
  margin-left 3em
  flex-wrap nowrap
  &:first-child
    margin-top 1em
  .post-comment__user-icon
    width 2em
    height 2em
    margin-right .6em
    margin-left .6em
</style>
